export default __webpack_public_path__ + "static/media/KarTent - Logo.179f6199.png";